import React, { FC } from 'react';
import { TypeImageCtaFields } from '@/core/generated-types';
import { Image } from '@/components/ui/Image';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

const ImageCta: FC<TypeImageCtaFields> = ({
  title,
  backgroundColor,
  media,
  titleAsH1 = false,
}) => {
  return (
    <div>
      {titleAsH1 ? (
        <Heading
          tag={HeadingTag.H1}
          size={HeadingSize.H1}
          classes="mb-8 md:mb-3 px-4 md:px-0"
          text={title}
          align="center"
        />
      ) : (
        <div className="mb-8 px-4 text-center text-[32px] font-bold leading-[37px] md:mb-3 md:px-0 md:text-[42px] md:leading-[56px]">
          {title}
        </div>
      )}

      <div className="flex items-stretch">
        <div
          className={`w-[10%] flex-none bg-${backgroundColor?.fields?.color} my-4`}
        />
        {media && (
          <div className="flex-auto">
            <Image
              className="h-60 w-full flex-auto rounded object-cover md:h-auto md:w-full"
              imageData={media}
              alt={media.fields.altText}
            />
          </div>
        )}
        <div
          className={`w-[10%] flex-none bg-${backgroundColor?.fields?.color} my-4`}
        />
      </div>
    </div>
  );
};

export default React.memo(ImageCta);
